import React from 'react'

const AllBooking = () => {
  return (
    <div>all-booking</div>
  )
}

export default AllBooking